<ejs-dialog #priceModelDialog [isModal]="true" [showCloseIcon]="true"
  [visible]="false" [width]="1800">
  <ng-template #header>
    {{'i18n.domain.client-administration.price-model.title' | translate}}
  </ng-template>
  <ng-template #content>
    <ejs-grid #grid [dataSource]="priceModels" [editSettings]="editSettings"
      class="price-model-grid"
      (actionBegin)="actionBegin($event)"
      (actionComplete)="actionComplete($event)"
      [toolbar]="toolbar" height="273px">
      <e-columns>
        <e-column field="Id" [isPrimaryKey]="true" [visible]="false"></e-column>
        <e-column field="navisionCustomerNumber" width="100px"
          clipMode="EllipsisWithTooltip"
          
          headerText="{{'i18n.domain.client-administration.price-model.fields.navisionCustomerNumber' | translate}}"></e-column>
        <e-column field="navisionProjectNumber" width="100px"
          clipMode="EllipsisWithTooltip"
          
          headerText="{{'i18n.domain.client-administration.price-model.fields.navisionProjectNumber' | translate}}"></e-column>
        <e-column field="validTo" width="115px" field="validTo"
          clipMode="EllipsisWithTooltip"
          
          headerText="{{'i18n.domain.client-administration.price-model.fields.validTo' | translate}}"
          type="date" clipMode="EllipsisWithTooltip" editType="datepickeredit">
          <ng-template #template let-data>
            {{data?.validTo | date:'dd.MM.yyyy'}}
          </ng-template>
        </e-column>
        <e-column width="100px" field="feesPaidByParkingSpaceOwner"
          headerText="{{'i18n.domain.client-administration.price-model.fields.feesPaidByParkingSpaceOwner' | translate}}"
          editType="booleanedit">
          <ng-template #template let-data>
            {{formatBoolean(data?.feesPaidByParkingSpaceOwner)}}
          </ng-template>
        </e-column>
        <e-column field="vatInPercent" width="100px"
          headerText="{{'i18n.domain.client-administration.price-model.fields.vATInPercent' | translate}}"
          textAlign="Right" editType="numericedit"
          [validationRules]='percentRules' format='#.00'></e-column>
        <e-column field="parkingPriceIncludedVATInPercent" width="100px"
          headerText="{{'i18n.domain.client-administration.price-model.fields.parkingPriceIncludedVatInPercent' | translate}}"
          textAlign="Right" editType="numericedit"
          [validationRules]='percentRules' format='#.00'></e-column>
        <e-column field="basePricePerMonth" width="100px"
          headerText="{{'i18n.domain.client-administration.price-model.fields.basePricePerMonth' | translate}}"
          textAlign="Right" editType="numericedit"
          [validationRules]='priceRules' format='#.00'></e-column>

        <e-column field="transactionMinimumPrice" width="100px"
          headerText="{{'i18n.domain.client-administration.price-model.fields.transactionMinimumPrice' | translate}}"
          textAlign="Right" editType="numericedit"
          [validationRules]='percentRules' format='#.00'></e-column>

        <e-column field="paymentProviderTransactionConstantPrice" width="100px"
          headerText="{{'i18n.domain.client-administration.price-model.fields.paymentProviderTransactionConstantPrice' | translate}}"
          textAlign="Right" editType="numericedit"
          [validationRules]='percentRules' format='#.00'></e-column>

        <e-column field="paymentProviderTransactionVariablePriceInPercent"
          width="100px"
          headerText="{{'i18n.domain.client-administration.price-model.fields.paymentProviderTransactionVariablePriceInPercent' | translate}}"
          textAlign="Right" editType="numericedit"
          [validationRules]='percentRules' format='#.00'></e-column>

        <e-column field="transactionConstantPrice" width="100px"
          headerText="{{'i18n.domain.client-administration.price-model.fields.transactionConstantPrice' | translate}}"
          textAlign="Right" editType="numericedit"
          [validationRules]='percentRules' format='#.00'></e-column>

        <e-column field="transactionVariablePriceInPercent" width="100px"
          headerText="{{'i18n.domain.client-administration.price-model.fields.transactionVariablePriceInPercent' | translate}}"
          textAlign="Right" editType="numericedit"
          [validationRules]='percentRules' format='#.00'></e-column>


        <e-column field="creditCardPaymentProviderTransactionConstantPrice" width="100px"
        headerText="{{'i18n.domain.client-administration.price-model.fields.creditCardPaymentProviderTransactionConstantPrice' | translate}}"
        textAlign="Right" editType="numericedit"
        [validationRules]='percentOrNullRules' format='#.00'></e-column>

        <e-column field="creditCardPaymentProviderTransactionVariablePriceInPercent" width="100px"
        headerText="{{'i18n.domain.client-administration.price-model.fields.creditCardPaymentProviderTransactionVariablePriceInPercent' | translate}}"
        textAlign="Right" editType="numericedit"
        [validationRules]='percentOrNullRules' format='#.00'></e-column>

        <e-column field="creditCardTransactionConstantPrice" width="100px"
        headerText="{{'i18n.domain.client-administration.price-model.fields.creditCardTransactionConstantPrice' | translate}}"
        textAlign="Right" editType="numericedit"
        [validationRules]='percentOrNullRules' format='#.00'></e-column>

        <e-column field="creditCardTransactionVariablePriceInPercent" width="100px"
        headerText="{{'i18n.domain.client-administration.price-model.fields.creditCardTransactionVariablePriceInPercent' | translate}}"
        textAlign="Right" editType="numericedit"
        [validationRules]='percentOrNullRules' format='#.00'></e-column>


        <e-column field="twintPaymentProviderTransactionConstantPrice" width="100px"
        headerText="{{'i18n.domain.client-administration.price-model.fields.twintPaymentProviderTransactionConstantPrice' | translate}}"
        textAlign="Right" editType="numericedit"
        [validationRules]='percentOrNullRules' format='#.00'></e-column>

        <e-column field="twintPaymentProviderTransactionVariablePriceInPercent" width="100px"
        headerText="{{'i18n.domain.client-administration.price-model.fields.twintPaymentProviderTransactionVariablePriceInPercent' | translate}}"
        textAlign="Right" editType="numericedit"
        [validationRules]='percentOrNullRules' format='#.00'></e-column>

        <e-column field="twintTransactionConstantPrice" width="100px"
        headerText="{{'i18n.domain.client-administration.price-model.fields.twintTransactionConstantPrice' | translate}}"
        textAlign="Right" editType="numericedit"
        [validationRules]='percentOrNullRules' format='#.00'></e-column>

        <e-column field="twintTransactionVariablePriceInPercent" width="100px"
        headerText="{{'i18n.domain.client-administration.price-model.fields.twintTransactionVariablePriceInPercent' | translate}}"
        textAlign="Right" editType="numericedit"
        [validationRules]='percentOrNullRules' format='#.00'></e-column>


        <e-column field="payPalPaymentProviderTransactionConstantPrice" width="100px"
        headerText="{{'i18n.domain.client-administration.price-model.fields.paypalPaymentProviderTransactionConstantPrice' | translate}}"
        textAlign="Right" editType="numericedit"
        [validationRules]='percentOrNullRules' format='#.00'></e-column>

        <e-column field="payPalPaymentProviderTransactionVariablePriceInPercent" width="100px"
        headerText="{{'i18n.domain.client-administration.price-model.fields.paypalPaymentProviderTransactionVariablePriceInPercent' | translate}}"
        textAlign="Right" editType="numericedit"
        [validationRules]='percentOrNullRules' format='#.00'></e-column>

        <e-column field="payPalTransactionConstantPrice" width="100px"
        headerText="{{'i18n.domain.client-administration.price-model.fields.paypalTransactionConstantPrice' | translate}}"
        textAlign="Right" editType="numericedit"
        [validationRules]='percentOrNullRules' format='#.00'></e-column>

        <e-column field="payPalTransactionVariablePriceInPercent" width="100px"
        headerText="{{'i18n.domain.client-administration.price-model.fields.paypalTransactionVariablePriceInPercent' | translate}}"
        textAlign="Right" editType="numericedit"
        [validationRules]='percentOrNullRules' format='#.00'></e-column>


        <e-column field="noOfIncludedAdmins" width="100px"
          headerText="{{'i18n.domain.client-administration.price-model.fields.noOfIncludedAdmins' | translate}}"
          textAlign="Right" editType="numericedit" width="100px"
          [validationRules]='numberRules' format='#'></e-column>

        <e-column field="pricePerAdditionalAdmin" width="100px"
          headerText="{{'i18n.domain.client-administration.price-model.fields.pricePerAdditionalAdmin' | translate}}"
          textAlign="Right" editType="numericedit"
          [validationRules]='percentRules' format='#.00'></e-column>

        <e-column field="noOfIncludedWebUser" width="100px"
          headerText="{{'i18n.domain.client-administration.price-model.fields.noOfIncludedWebUser' | translate}}"
          textAlign="Right" editType="numericedit"
          [validationRules]='numberRules' format='#'></e-column>

        <e-column field="pricePerAdditionalWebUser" width="100px"
          headerText="{{'i18n.domain.client-administration.price-model.fields.pricePerAdditionalWebUser' | translate}}"
          textAlign="Right" editType="numericedit"
          [validationRules]='percentRules' format='#.00'></e-column>

        <e-column field="noOfIncludedParkingRanger" width="100px"
          headerText="{{'i18n.domain.client-administration.price-model.fields.noOfIncludedParkingRanger' | translate}}"
          textAlign="Right" editType="numericedit"
          [validationRules]='numberRules' format='#'></e-column>

        <e-column field="pricePerAdditionalParkingRanger" width="100px"
          headerText="{{'i18n.domain.client-administration.price-model.fields.pricePerAdditionalParkingRanger' | translate}}"
          textAlign="Right" editType="numericedit"
          [validationRules]='percentRules' format='#.00'></e-column>

        <e-column field="noOfIncludedDevices" width="100px"
          headerText="{{'i18n.domain.client-administration.price-model.fields.noOfIncludedDevices' | translate}}"
          textAlign="Right" editType="numericedit"
          [validationRules]='numberRules' format='#'></e-column>

        <e-column field="pricePerAdditionalDevice" width="100px"
          headerText="{{'i18n.domain.client-administration.price-model.fields.pricePerAdditionalDevice' | translate}}"
          textAlign="Right" editType="numericedit"
          [validationRules]='percentRules' format='#.00'></e-column>

        <e-column field="noOfIncludedProxies" width="100px"
          headerText="{{'i18n.domain.client-administration.price-model.fields.noOfIncludedProxies' | translate}}"
          autoParkingActive
          textAlign="Right" editType="numericedit"
          [validationRules]='numberRules' format='#'></e-column>

        <e-column field="pricePerAdditionalProxy" width="100px"
          headerText="{{'i18n.domain.client-administration.price-model.fields.pricePerAdditionalProxy' | translate}}"
          textAlign="Right" editType="numericedit"
          [validationRules]='percentRules' format='#.00'></e-column>

        <e-column field="autoParkingActive" width="100px" editType="booleanedit"
          headerText="{{'i18n.domain.client-administration.price-model.fields.autoParkingActive' | translate}}">
          <ng-template #template let-data>
            {{formatBoolean(data?.autoParkingActive)}}
          </ng-template>
        </e-column>

        <e-column field="pricePerAutoParkingParkerPerMonth" width="100px"
          headerText="{{'i18n.domain.client-administration.price-model.fields.pricePerAutoParkingParkerPerMonth' | translate}}"
          textAlign="Right" editType="numericedit"
          [validationRules]='percentRules' format='#.00'></e-column>

        <e-column field="thirdPartyInterfaceActive" width="100px"
          editType="booleanedit"
          headerText="{{'i18n.domain.client-administration.price-model.fields.thirdPartyInterfaceActive' | translate}}">
          <ng-template #template let-data>
            {{formatBoolean(data?.thirdPartyInterfaceActive)}}
          </ng-template>
        </e-column>

        <e-column field="pricePerThirdPartyInterface" width="100px"
          headerText="{{'i18n.domain.client-administration.price-model.fields.pricePerThirdPartyInterface' | translate}}"
          textAlign="Right" editType="numericedit"
          [validationRules]='percentRules' format='#.00'></e-column>

        <e-column field="noOfIncludedParkingSpaces" width="100px"
          headerText="{{'i18n.domain.client-administration.price-model.fields.noOfIncludedParkingSpaces' | translate}}"
          textAlign="Right" editType="numericedit"
          [validationRules]='numberRules' format='#'></e-column>

        <e-column field="noOfIncludedParkers" width="100px"
          headerText="{{'i18n.domain.client-administration.price-model.fields.noOfIncludedParkers' | translate}}"
          textAlign="Right" editType="numericedit"
          [validationRules]='numberRules' format='#'></e-column>

        <e-column field="parkingSpacePriceModelName" width="180px"
          headerText="{{'i18n.domain.client-administration.price-model.fields.parkingSpacePriceModelName' | translate}}"
          clipMode="EllipsisWithTooltip">
          <ng-template #editTemplate let-data>
            <ejs-dropdownlist
              [(ngModel)]="priceModel.parkingSpacePriceModelName"
              [dataSource]="priceModelMasterData.parkingSpacePriceModels"
              [fields]="dropDownFields" popupWidth="250px">
            </ejs-dropdownlist>
          </ng-template>
        </e-column>
        <e-column field="parkerPriceModelName" width="180px"
          headerText="{{'i18n.domain.client-administration.price-model.fields.parkerPriceModelName' | translate}}"
          clipMode="EllipsisWithTooltip">
          <ng-template #editTemplate let-data>
            <ejs-dropdownlist [(ngModel)]="priceModel.parkerPriceModelName"
              [dataSource]="priceModelMasterData.parkerPriceModels"
              [fields]="dropDownFields" popupWidth="250px">
            </ejs-dropdownlist>
          </ng-template>
        </e-column>
      </e-columns>
    </ejs-grid>
  </ng-template>
  <ng-template #footerTemplate>
    <button class="btn btn-secondary me-2" (click)="closePriceModelDialog()">
      {{'i18n.shared.close' | translate}}
    </button>
  </ng-template>
</ejs-dialog>